import axios from "axios";

export const getMemberVoteProposal = async (
  memberType,
  memberCode,
  proposalCode
) => {
  try {
    let url = `${process.env.REACT_APP_BACKEND_URL}/ballots/memberVoteProposal`;

    if (memberType !== undefined) {
      url += `?memberType=${memberType}`;
    }
    if (memberCode !== undefined) {
      url += `${memberType !== undefined ? "&" : "?"}memberCode=${memberCode}`;
    }

    if (proposalCode !== undefined) {
      url += `${
        memberCode !== undefined ? "&" : "?"
      }proposalCode=${proposalCode}`;
    }

    const response = await axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      url: url,
    });
    return response.data.voteData;
  } catch (error) {
    throw error;
  }
};

export const getBallotResultProposal = async (proposalCode) => {
  try {
    let url = `${process.env.REACT_APP_BACKEND_URL}/ballots/getBallotResult`;

    if (proposalCode !== undefined) {
      url += `?proposalCode=${proposalCode}`;
    }

    const response = await axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      url: url,
    });
    return response.data.ballotResult;
  } catch (error) {
    throw error;
  }
};
